<div class="support-container">
  <div class="communication-container">
    <dk-support-inquiries
      #inquiries
      [selectedInquiryId]="selectedInquiryId"
      (tabChanged)="onTabChanged($event)"
      (chatSelected)="onChatSelected($event)"
      (newChatSelected)="onNewChatSelected($event)"></dk-support-inquiries>
  </div>
  <p-divider layout="vertical" [style]="{ height: '100%' }"></p-divider>
  <div class="chat-container" [ngClass]="{ 'chat-active': selectedInquiryId != '' }">
    <dk-support-chats
      (chatCreated)="onChatCreated($event)"
      [inquiryId]="selectedInquiryId"
      [chatPanelType]="forcePanelType"
      [currentInquiryKey]="currentInquiryKey"></dk-support-chats>
  </div>
</div>
